import baseFetch from './baseFetch';


export default async function(formData, category, token_user) {
    token_user;
    const request = await baseFetch("api/save_compose", {
        method: "POST",
        body: formData,
    });
    return await request;
}
